<template>
  <div class="help-center__faq">
    <h2 class="help-center__title">
      <img
        src="/static/images/icon-faq-purple.svg"
        alt="icone-download"
      >
      <span>FAQ</span>
      <p>Perguntas frequentes:</p>
    </h2>
    <accordion
      :content="content"
      @getAction="pushEventToAnalytics"
    />
    <div class="help-center__more-answer">
      <router-link to="/perguntas-frequentes">
        Ver mais respostas
      </router-link>
    </div>
  </div>
</template>

<script>
import Accordion from '../common/Accordion.vue'
import { mapGetters } from 'vuex'

export default {
  name: 'HelpCenterFaq',
  components: {
    Accordion
  },
  data: () => ({
    content: [
      {
        id: 1,
        title: 'Como importar um arquivo XML para cadastrar as Ordens de Serviço?',

        content:
          'Para cadastrar um volume maior de dados de uma só vez é possível utilizar a importação de XML. Primeiro exporte os dados de pacientes e ordens de serviço a partir do seu sistema LIS (Laboratory Information System) no formato XML, e então importe-o no AOL 2.0. Para importar o XML no sistema, basta clicar no menu lateral “Importar arquivo XML” ou na página inicial no card “Rotinas diárias” e clicar em ”Importar arquivo XML". <br> <b>Nota:</b> seu laboratório precisa ter a exportação XML configurada no formato Alvaro. Em caso de dúvidas, entre em contato através do número: 0800 643 8100 e solicite suporte.'
      },
      {
        id: 2,
        title: 'Qual a importância de realizar o loteamento correto das amostras?',
        content:
          'Para garantir a rastreabilidade de ponta a ponta é muito importante que as amostras sejam loteadas corretamente, ou seja, enviadas nas bags Alvaro Apoio devidamente identificadas. O sistema cria os lotes automaticamente, de acordo com o destino e acondicionamento. Cada lote possui um código de identificação e esse código é igual ao das amostras, o que facilita a separação das amostras nas bags. Cada bag representa um Lote, portanto deve conter apenas uma etiqueta de Lote.'
      },
      {
        id: 3,
        title: 'Como acompanhar onde minha amostra se encontra?',
        content:
          'Na seção “Rastreabilidade - logística” a ferramenta disponibiliza um panorama geral de quantas amostras estão aguardando retirada e quantas já foram encaminhadas para o Núcleo Técnico Operacional (NTO) do Alvaro Apoio. Se a amostra rastreada estiver em trânsito, é possível visualizar o mapa com sua localização exata em tempo real. Já na seção “Rastreabilidade - produção” é possível acompanhar a quantidade de exames em triagem, em execução, quantos foram liberados e também os exames em atraso.'
      },
      {
        id: 4,
        title: 'Como visualizar as pendências?',
        content:
          'Na página inicial é possível visualizar o alerta “Pendências” identificando a quantidade de itens a serem respondidos. Ao clicar no card você terá acesso a todas as pendências do seu laboratório. Para facilitar a gestão das pendências é possível ordenar por nome do paciente, status ou data da pendência.'
      },
      {
        id: 5,
        title: 'Como buscar os laudos que foram liberados?',
        content:
          'Para facilitar sua rotina, o Alvaro Apoio disponibiliza os resultados de exames em dois formatos: PDF e XML. Acesse o menu lateral e clique em “Resultados de Exames” ou na página inicial no card “Rastreabilidade - produção”, em qualquer uma dessas alternativas é possível visualizar as opções Laudos em PDF” e “Resultados em XML”.'
      }
    ]
  }),
  methods: {
    pushEventToAnalytics(action) {
      this.$analytics.pushAnalyticsEvent('ga-event', {
        category: 'Central de Ajuda',
        action: 'FAQ - ' + action,
        'id-user': this.profile.id,
        'id-lab': this.profile.id_laboratory,
        'name-lab': this.profile.laboratoryName
      })
    }
  },
  computed: {
    ...mapGetters(['profile'])
  }
}
</script>
